import Util from './../util';

const CODE = {
    TIMEOUT: -1,
    PERMISSION_DENIED: 401,
    NO_ACCESS: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500
};

const PATTERN = {
    TIMEOUT:
        'A timeout occurred while loading {0}. Check your network connection or try to reduce the amount of data requested (e.g. use a smaller date range)!',
    PERMISSION_DENIED:
        'You are not allowed to access {0}. Please check if you have sufficient permissions and try to log out and back in again!',
    NO_ACCESS: 'You are not allowed to access {0}. Please check if you have sufficient permissions!',
    NOT_FOUND: '{0} is currently unavailable. Please try again in a moment!',
    INTERNAL_SERVER_ERROR: '{0} could not be loaded due to technical issues. Please try again in a moment!'
};

const ERROR_MESSAGES = {
    TIMEOUT:
        'A timeout occurred while loading the resource. Check your network connection or try to reduce the amount of data requested (e.g. use a smaller date range)!',
    PERMISSION_DENIED:
        'You are not allowed to access the requested resource. Please check if you have sufficient permissions and try to log out and back in again!',
    NO_ACCESS: 'You are not allowed to access the requested resource. Please check if you have sufficient permissions!',
    NOT_FOUND: 'The requested resource is currently unavailable. Please try again in a moment!',
    INTERNAL_SERVER_ERROR: 'The request failed due to technical issues. Please try again in a moment!'
};

export default {
    buildErrorInfo(error) {
        const info = {
            response: {
                status: error.status,
                message: error.statusText,
                data: error.data
            }
        };

        if (typeof error.headers === 'function') {
            info.response.headers = error.headers();
        }

        let cause;
        if (error.config) {
            info.request = {
                method: error.config.method,
                url: error.config.url,
                headers: error.config.headers,
                data: error.config.data
            };

            if (info.request.url.includes('reporting/incidents')) {
                cause = 'incidents';
            } else if (info.request.url.includes('reporting/kpi')) {
                cause = 'this KPI';
            }
        }

        let message = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
        if (typeof cause === 'string') {
            switch (info.response.status) {
                case CODE.TIMEOUT:
                    message = Util.string.format(PATTERN.TIMEOUT, cause);
                    break;
                case CODE.NOT_FOUND:
                    message = Util.string.format(PATTERN.NOT_FOUND, Util.string.firstToUpper(cause));
                    break;
                case CODE.NO_ACCESS:
                    message = Util.string.format(PATTERN.NO_ACCESS, cause);
                    break;
                case CODE.PERMISSION_DENIED:
                    message = Util.string.format(PATTERN.PERMISSION_DENIED, cause);
                    break;
                default:
                    message = Util.string.format(PATTERN.INTERNAL_SERVER_ERROR, Util.string.firstToUpper(cause));
                    break;
            }
        } else {
            switch (info.response.status) {
                case CODE.TIMEOUT:
                    message = ERROR_MESSAGES.TIMEOUT;
                    break;
                case CODE.NOT_FOUND:
                    message = ERROR_MESSAGES.NOT_FOUND;
                    break;
                case CODE.NO_ACCESS:
                    message = ERROR_MESSAGES.NO_ACCESS;
                    break;
                case CODE.PERMISSION_DENIED:
                    message = ERROR_MESSAGES.PERMISSION_DENIED;
                    break;
            }
        }

        if (info.request && info.request.headers) {
            const replacement = '**********';
            if (info.request.headers.Authorization) {
                info.request.headers.Authorization = replacement;
            }
            if (info.request.headers.IDToken) {
                info.request.headers.IDToken = replacement;
            }
        }

        return { message, info };
    }
};
